import React from 'react';

class FooterBar extends React.Component
{
    constructor() {
        super()
    }

    render()
    {
        return (
            <div id='Footer'>
                <p>Realization Lion &copy; 2022. All Rights Reserved.</p>
            </div>
        );
    }
}

export default FooterBar;